var _style, _g, _path, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTucanfiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1423.7 402.5",
    style: {
      enableBackground: "new 0 0 1423.7 402.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#15112C;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000162330998829136172380000016814622401967536005_);}\n\t.st3{fill:url(#SVGID_00000149379085633813538830000010611115682850654115_);}\n\t.st4{fill:url(#SVGID_00000121255041566442625280000017657647982807805617_);}\n\t.st5{fill:url(#SVGID_00000051348969113704417410000015254789767843503805_);}\n\t.st6{fill:url(#SVGID_00000041292739264145091180000009058339882686106540_);}\n\t.st7{fill:url(#SVGID_00000026864591627550295470000008024665524591278771_);}\n\t.st8{fill:url(#SVGID_00000113313519632996504950000005459360946784397714_);}\n\t.st9{fill:url(#SVGID_00000132771483944092532360000003012859670742321044_);}\n\t.st10{fill:url(#SVGID_00000142871494839916766230000009207103875964523398_);}\n\t.st11{fill:url(#SVGID_00000081639507806131163340000003207435731823981707_);}\n\t.st12{fill:url(#SVGID_00000050625170679249133890000006063656958927076489_);}\n\t.st13{fill:url(#SVGID_00000152245246555778527740000012532939767059816073_);}\n\t.st14{fill:url(#SVGID_00000052103990268310509300000001094718549005592252_);}\n\t.st15{fill:none;stroke:#15112C;stroke-width:5.6691;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:3;}\n\t.st16{fill:none;stroke:#15112C;stroke-width:5.6691;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:3.9998;}\n\t.st17{fill:url(#SVGID_00000047769165242116896000000017464961905988502418_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-4.1-0.8v404.6h1427.6V-0.8H-4.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.09423828125, 0, 0, 1.09423828125, 95.2,910.4) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -182.9689,
    y1: -286.367,
    x2: 649.756,
    y2: -286.367,
    gradientTransform: "matrix(1.1973 0 0 1.1973 191.9063 -308.0785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A81D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    style: {
      stopColor: "#FDD744"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4275,
    style: {
      stopColor: "#2FE52D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6471,
    style: {
      stopColor: "#41E1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    style: {
      stopColor: "#4E38B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.9-674.7c4.9,1.3,8.4,2.6,10.6,3.8v-17.5c-4.5-2.2-9.3-3.8-14.4-4.7c-5.2-0.9-10.3-1.3-15.2-1.3 c-12.8,0-24,2.6-33.5,7.9c-9.4,5.2-16.8,13-22.1,23.4c-5.2,10.2-7.8,22.8-7.9,37.8c0.1,15.1,2.7,27.8,7.9,38.1 c5.3,10.2,12.7,18,22.1,23.4c9.5,5.3,20.7,7.9,33.5,7.9c4.9,0,10-0.4,15.2-1.3c5.1-1,9.9-2.5,14.4-4.7v-17.5 c-2,1.3-5.6,2.6-10.8,3.9c-5.1,1.2-11.1,1.8-18.1,1.9c-12.9,0.1-23-4.2-30.3-12.8c-7.4-8.6-11.2-21.7-11.3-39.3 c0-16.1,3.6-28.6,10.8-37.5c7.1-8.8,17.4-13.3,30.8-13.4C290-676.7,296.1-676,300.9-674.7 M81.6-690.7v79.2 c0,19.8,4,34,11.9,42.8c7.9,8.6,19.7,12.8,35.3,12.6c8.1-0.1,14.8-1.5,20.1-4.1c5.4-2.6,9.7-6,13-10.2c3.4-4.1,6.1-8.4,8.3-12.9 h2.2l4.1,23h15.9v-130.5h-22v80.4c-0.1,5.9-1.7,11.5-4.8,17c-3.1,5.4-7.4,9.8-12.8,13.2c-5.4,3.5-11.6,5.2-18.6,5.3 c-7-0.1-12.7-1.6-17.3-4.5c-4.5-3-7.8-7-10-12.2c-2.2-5.1-3.2-10.9-3.2-17.3V-691H81.6 M-40.1-737.8v17.5H7.3v160.1h21.8v-160.1 h48.7v-17.5L-40.1-737.8 M443.5-639.5c0-19.8-4.6-34.1-13.6-42.7c-9-8.5-21.9-12.7-38.6-12.6c-12.1,0.1-21.4,0.8-27.9,2.3 c-6.6,1.5-11.4,3-14.5,4.5v17.2c0.1-0.1,1.9-0.7,5.4-1.8c3.5-1,8-2,13.6-3.1c5.6-1,11.7-1.6,18.2-1.7c11.7,0.1,20.5,2.8,26.1,8.2 c5.6,5.4,8.5,12.6,8.9,21.8l-53.4,5.6c-7.9,0.9-14.3,3.4-19.2,7.5c-5,4-8.8,8.9-11.1,14.8c-2.4,5.9-3.6,12-3.6,18.3 c0.1,13.5,3.3,24.2,9.6,32.2s15.3,12.1,27,12.3c7.6-0.2,14.4-1.8,20.4-5c6.1-3.2,11.5-7.1,16.4-11.8s9.2-9.2,13-13.8h2.2 l6.8,26.9h14.5v-79.1 M421.7-631.8v25.7c-2.8,4.4-6.6,8.7-11.5,13.1c-5,4.4-10.5,8.1-16.5,11.1s-12,4.6-18,4.8 c-6.8,0-11.8-2.2-15-6.8c-3.1-4.6-4.7-10.4-4.5-17.4c0-7.2,1.8-12.6,5.3-16.2c3.5-3.7,8.8-6.1,15.8-7.1L421.7-631.8 M585.1-560.2 v-79.3c0-19.8-4-34.1-12-42.7c-8-8.5-19.8-12.7-35.5-12.6c-7.9,0.1-14.5,1.4-19.6,4.1c-5.2,2.6-9.4,6-12.7,10.1 c-3.2,4.1-5.9,8.4-8,13h-2.2l-5.4-23.9L474-690v129.7h21.8v-82c0-5.8,1.4-11.3,4.1-16.5s6.6-9.5,11.6-12.8c5.1-3.3,11.1-5,18.1-5 c8.4,0.1,15.1,1.6,20,4.5c4.9,3,8.3,7.1,10.2,12.3c2.1,5.1,3.1,11,3,17.5v82h22.3 M734.1-690.7l-1.5,17.5h27.7v95.5h-33.8 l-0.2,17.5H816l-1.2-17.5h-32.5v-113H734.1 M710.2-720.3v-17.5h-95.1v177.6h21.3v-81.5h64.7l-1.5-17.5h-63.2v-61.1L710.2-720.3  M752.5-727.3c0.1,5.7,1.9,10.3,5.2,13.7s7.8,5.1,13.4,5.2c5.6-0.1,10-1.8,13.2-5.2s4.9-8,5-13.7c-0.1-5.6-1.8-10.1-5-13.5 s-7.6-5.1-13.2-5.2c-5.6,0.1-10.1,1.8-13.4,5.2C754.4-737.4,752.6-732.9,752.5-727.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.933135986328125, 0, 0, 0.933135986328125, 250.9,-21.75) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159456783172431395270000011603863931310698882_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.47,
    y1: 747.1542,
    x2: 712.72,
    y2: 833.6791,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E3BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41E1E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159456783172431395270000011603863931310698882_)"
    },
    d: "M969.6,256.8c0.6-5.7-0.3-12.8-2.8-21.2 c-1.2-4.2-2-8.4-2.5-12.8l-64.9,136c15.1,2,28.8,2.2,41.1,0.4c8.1-1.2,15.5-3.3,22.4-6.2c-9.3-10.1-14.7-19.7-16.2-28.7 c-1.5-9.1-1.5-16.9,0-23.4c1.6-6.6,4.1-12.2,7.6-16.9c3.5-4.7,6.8-9,9.8-12.8C967.1,267.1,968.9,262.3,969.6,256.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141426572827883829530000009233109032848979367_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.6181,
    y1: 792.4614,
    x2: 398.443,
    y2: 790.5864,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E3BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141426572827883829530000009233109032848979367_)"
    },
    d: "M822.4,312.8 c5,14.9,16.1,26.3,33.3,34.3c5.2,2.4,10.9,4.5,17.3,6.4l1.3-30.1c-2.5-0.2-5.2-0.6-8.1-1.3C850.2,323.2,835.6,320.1,822.4,312.8z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135651911319577260630000009753199898473061817_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.2577,
    y1: 885.0656,
    x2: 431.9326,
    y2: 827.0656,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A68C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135651911319577260630000009753199898473061817_)"
    },
    d: "M842.8,398.3l-15.3,20.2 c16.8,1.2,31.2-3,43.2-12.9c5.7-4.6,10.6-9.1,14.7-13.3c4.6-4.7,8.3-9.1,11-13.3c-2.7,4.2-6.4,8.6-11,13.3l-5.9,14.3 c9.2-2.4,18-6.2,26.2-11.3c8.2-5.3,15.4-11.4,21.6-18.4c6.1-7,10.5-12.9,13.2-17.8c-12.3,1.8-26,1.7-41.1-0.4 c-5.4-0.8-10.9-1.7-16.6-2.9c-3.4-0.8-6.6-1.5-9.7-2.3c-6.4-1.9-12.2-4-17.3-6.4c-21.4,23.6-45.9,46.9-73.6,70 c16.1,2.9,32.7-1,49.9-11.7C835.8,403,839.4,400.7,842.8,398.3c12.1-8.4,21.9-16.7,29.5-25C864.7,381.6,854.9,389.9,842.8,398.3z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121968891927541441040000011313580228670555040_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.6328,
    y1: 745.0473,
    x2: 388.2578,
    y2: 729.9722,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E3BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121968891927541441040000011313580228670555040_)"
    },
    d: "M820.3,265c-8.1-8-13.7-16-16.8-24 c0.2,20.4,4.7,36.6,13.5,48.6c8.8,11.9,18.7,20.4,29.6,25.4c7.3,3.4,13.9,5.8,19.8,7.1c2.9,0.7,5.6,1.1,8.1,1.3l4.8-31 c-10.2-2.1-19.6-5.6-28.3-10.5C838.6,278.6,828.3,273,820.3,265z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083071823114507357410000006822353690275431586_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.8052,
    y1: 689.6597,
    x2: 396.7552,
    y2: 661.2347,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E3BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083071823114507357410000006822353690275431586_)"
    },
    d: "M840.1,220.7c-4-6.8-7.2-14.3-9.5-22.5 c-2.1-7.6-3.2-20.2-3.4-37.8C815.1,174.9,810,192,812,211.5c2.1,19.6,6.3,34.5,12.5,44.5c6.3,10.1,14.1,18.1,23.5,24.2 c1,0.6,1.9,1.1,2.9,1.8c8.7,4.9,18.1,8.4,28.3,10.5l10-27.2c-14.6-7.2-25.5-16.2-32.6-27.1C849.6,233.2,844.1,227.5,840.1,220.7z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029037700864637779770000006963592478419819709_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.3349,
    y1: 702.4622,
    x2: 433.935,
    y2: 615.5372,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E3BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B44097"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029037700864637779770000006963592478419819709_)"
    },
    d: "M891.8,214.9 c-7.1-5.4-12.8-12.2-17.2-20.5s-7.7-19.9-10.1-34.9c-2.4-15-1.3-31.3,3.3-49c-12.6,10.6-21.1,25.7-25.7,45.4 c-4.7,19.7-3.4,39.9,3.8,60.6c2.8,7.8,6.3,15,10.6,21.6c7.1,10.9,18,20,32.6,27.1l-10,27.2l-4.8,31l-1.3,30.1 c3.1,0.8,6.3,1.5,9.7,2.3c5.7,1.2,11.2,2.2,16.6,2.9l64.9-136c-0.5-4.6-0.7-9.2-0.4-14c0.6-9.5,3.8-18,9.8-25.4 c1.7-2,3.8-4.5,6.6-7.3c-1.9,1.4-3.8,3.1-5.8,5c-8.3,8.2-14.6,15.9-18.9,23.2c-4.4,7.2-8.1,12.6-11.2,16.1 c-3.1,3.5-7.7,5.8-13.8,7c-6.2,1.1-12.4,0.6-18.7-1.3C905.6,223.9,898.9,220.2,891.8,214.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106136954949387465690000015781496152948637826_",
    gradientUnits: "userSpaceOnUse",
    x1: 672.4206,
    y1: 644.7943,
    x2: 706.2455,
    y2: 598.3192,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD5838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9637"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106136954949387465690000015781496152948637826_)"
    },
    d: "M1065.4,205.2c-3.8,3.6-7,4.2-9.8,1.9 l16.9,17.2c1.7,1.5,3.2,2.2,4.8,2.2c1,0,2-0.4,3-1.1c0.7-0.6,1.4-1.4,2-2.5l40-49c7.7-13.7,9.2-24,4.7-30.9L1065.4,205.2  M1054.9,206.4l-1.1-1.2h-0.1L1054.9,206.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050646146746160897890000014231089722094036925_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.6908,
    y1: 653.2028,
    x2: 556.9156,
    y2: 703.6527,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2FE52D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41E1E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050646146746160897890000014231089722094036925_)"
    },
    d: "M1055.6,207.1l-0.1-0.2l-0.6-0.5 l-1.2-1.2h0.1l-46.2-46.8c-1.3-1.3-1.9-2.7-1.9-4.2c0-2.4,1.4-5.2,4.4-8.3c-13.2,12.6-23.2,22.6-30,30c-2.7,2.9-4.9,5.3-6.6,7.3 c-5.9,7.4-9.2,15.9-9.8,25.4c-0.3,4.8-0.2,9.5,0.4,14c0.5,4.4,1.3,8.6,2.5,12.8c2.5,8.5,3.4,15.6,2.8,21.2 c-0.6,5.6-2.5,10.3-5.5,14.3c-3,3.9-6.3,8.1-9.8,12.8c-3.5,4.7-6,10.3-7.6,16.9c-1.5,6.6-1.5,14.4,0,23.4c1.6,9,7,18.6,16.2,28.7 c0.1,0,0.2-0.1,0.3-0.1c8.9-3.6,17.1-8.9,24.8-15.9c6.4-5.7,12.1-12.7,17.1-20.8c5.1-8.2,9.1-17,12.1-26.6 c2.9-9.6,7.7-17.9,14.3-24.9c6.6-7.1,14.5-13.4,23.6-19.1c9.1-5.7,17.2-12.1,24.3-19c0.4-0.4,0.7-0.7,1-1.1c-1,0.8-2,1.1-3,1.1 c-1.5,0-3.1-0.8-4.8-2.2L1055.6,207.1 M995.1,190c2.9-1.2,6-1.8,9.4-1.8c6.8,0,12.6,2.4,17.3,7.2c4.9,4.9,7.3,10.7,7.3,17.5 s-2.4,12.7-7.3,17.5c-4.7,4.8-10.5,7.2-17.3,7.2c-6.7,0-12.4-2.3-17.2-7c-0.1-0.1-0.2-0.2-0.3-0.2c-4.8-4.8-7.2-10.7-7.2-17.5 s2.4-12.6,7.2-17.5C989.5,193,992.2,191.2,995.1,190z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093893200224910168790000006895890760076813200_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.364,
    y1: 676.3302,
    x2: 590.3389,
    y2: 645.1552,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD91E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7FF32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093893200224910168790000006895890760076813200_)"
    },
    d: "M1004.5,188.2c-3.4,0-6.5,0.6-9.4,1.8 s-5.6,3-8.1,5.5c-4.8,4.9-7.2,10.7-7.2,17.5s2.4,12.7,7.2,17.5c0.1,0.1,0.2,0.1,0.3,0.2c4.8,4.6,10.5,7,17.2,7 c6.8,0,12.6-2.4,17.3-7.2c4.9-4.8,7.3-10.7,7.3-17.5s-2.4-12.6-7.3-17.5C1017.1,190.6,1011.4,188.2,1004.5,188.2 M994.9,203.5 c2.6-2.6,5.8-3.9,9.5-3.9s6.9,1.3,9.4,3.9c2.6,2.6,3.9,5.8,3.9,9.5s-1.3,6.8-3.9,9.4c-2.5,2.6-5.7,3.9-9.4,3.9s-6.8-1.3-9.5-3.9 c-2.5-2.6-3.8-5.7-3.8-9.4C991.1,209.3,992.3,206.2,994.9,203.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168090252801520236200000015671617242422113409_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.6885,
    y1: 664.7807,
    x2: 587.7635,
    y2: 648.0557,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#080A21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#432ED4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168090252801520236200000015671617242422113409_)"
    },
    d: "M1004.3,199.6c-3.7,0-6.8,1.3-9.5,3.9 c-2.5,2.6-3.8,5.8-3.8,9.5s1.3,6.8,3.8,9.4c2.6,2.6,5.8,3.9,9.5,3.9s6.9-1.3,9.4-3.9c2.6-2.6,3.9-5.7,3.9-9.4s-1.3-6.9-3.9-9.5 C1011.2,200.9,1008.1,199.6,1004.3,199.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115497732468928457180000006911339790225262515_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.0541,
    y1: 526.3632,
    x2: 682.2292,
    y2: 624.2883,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEF4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD882D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115497732468928457180000006911339790225262515_)"
    },
    d: "M1106.9,91.1 c-14.9-12.3-32.5-9.9-53,7.2l-43.8,47.6c-3,3.1-4.4,5.9-4.4,8.3c0,1.5,0.6,2.9,1.9,4.2l46.2,46.8l1.1,1.2l0.6,0.5l0.1,0.2 c2.8,2.4,6,1.7,9.8-1.9L1127,143l15.9-16.2L1106.9,91.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034783808286488751530000013529121551295399608_",
    gradientUnits: "userSpaceOnUse",
    x1: 769.3075,
    y1: 550.6725,
    x2: 691.0825,
    y2: 623.9724,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF1DC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDAD37"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034783808286488751530000013529121551295399608_)"
    },
    d: "M1172.4,100.8 c-6.1,4.2-12.1,9-17.9,14.3l-11.6,11.6L1127,143c4.5,6.9,3,17.2-4.7,30.9l42.3-51.7C1171.4,113.8,1174,106.7,1172.4,100.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004507537679530052850000017735224488862749074_",
    gradientUnits: "userSpaceOnUse",
    x1: 768.0031,
    y1: 506.1039,
    x2: 579.8279,
    y2: 548.0039,
    gradientTransform: "matrix(0.8707 0 0 0.8707 490.8901 -355.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD4EA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDAD37"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004507537679530052850000017735224488862749074_)"
    },
    d: "M1154.5,115.1 c5.8-5.3,11.8-10.1,17.9-14.3c7.6-5.3,15.3-9.7,23.2-13.2c-22.4-23.8-44.6-34.9-66.6-33.4c-22.9,1.5-46.6,14.8-71,39.9l-4.1,4.2 c20.5-17.1,38.1-19.5,53-7.2l36,35.6L1154.5,115.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0716400146484375, 0, 0, 1.0716400146484375, -268.85,23.3) "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_MEMBER_1_1_STROKES",
    className: "st15",
    d: "M1319.5,95.1l10.9-11c5.5-5,11.1-9.5,16.9-13.5c7.2-5,14.5-9.2,21.9-12.5 c-21.2-22.5-42.1-33-62.9-31.6c-21.6,1.4-44,14-67.1,37.7l-3.8,4c19.4-16.2,36-18.4,50.1-6.8L1319.5,95.1z M1319.5,95.1l-15,15.4  M1237,171.1l-0.1-0.2 M1235.3,169.3l-43.6-44.1c-1.2-1.2-1.8-2.6-1.8-4c0-2.3,1.3-4.9,4.2-7.8c-12.5,11.9-21.9,21.3-28.3,28.3 c-2.6,2.7-4.6,5-6.1,6.9c-5.6,7-8.7,15-9.2,24c-0.3,4.5-0.2,9,0.3,13.2c0.5,4.2,1.3,8.1,2.4,12.1c2.4,8,3.2,14.7,2.6,20 c-0.6,5.3-2.3,9.7-5.1,13.5c-2.8,3.7-6,7.7-9.3,12.1c-3.3,4.4-5.7,9.7-7.2,16c-1.4,6.2-1.4,13.6,0,22.1 c1.5,8.5,6.6,17.6,15.3,27.1c0.1,0,0.2-0.1,0.3-0.1c8.4-3.4,16.2-8.4,23.3-15c6-5.4,11.4-12,16.2-19.7c4.8-7.7,8.6-16.1,11.3-25.1 c2.7-9.1,7.3-16.9,13.4-23.5c6.2-6.7,13.7-12.7,22.2-18c8.6-5.4,16.3-11.4,23-18c0.4-0.4,0.7-0.7,0.9-1 M1246.3,169.3 c-3.6,3.4-6.6,4-9.3,1.7 M1304.5,110.5l-58.2,58.8 M1236.3,170.4l-1-1 M1049,200.4c-4.1-6.2-7.4-12.9-10-20.3 c-6.8-19.7-8-38.7-3.6-57.3c4.3-18.6,12.4-32.9,24.3-42.9c-4.4,16.7-5.5,32.1-3.1,46.3c2.3,14.2,5.4,25.1,9.5,33 c4.1,7.8,9.4,14.3,16.2,19.4c6.7,5.1,13,8.5,19,10.4c6,1.9,11.8,2.3,17.6,1.2c5.8-1.1,10.1-3.3,12.9-6.6 c2.8-3.4,6.3-8.4,10.5-15.2c4.1-6.8,10-14.1,17.9-21.8c1.8-1.8,3.6-3.4,5.4-4.7 M1043.6,241.8c-0.9-0.6-1.8-1.1-2.7-1.7 c-8.9-5.7-16.3-13.3-22.2-22.8c-5.9-9.5-9.8-23.5-11.8-42c-1.9-18.4,2.9-34.5,14.4-48.3c0.2,16.6,1.2,28.5,3.2,35.7 c2.2,7.7,5.2,14.8,9,21.3c3.7,6.3,8.9,11.8,15.6,16.3c6.7,10.3,17,18.8,30.8,25.6 M1073.7,311.6c-3.2-0.8-6.2-1.4-9.2-2.2  M1089.4,314.4c-5.1-0.8-10.3-1.6-15.7-2.7 M1058.1,279.7c-5.6-1.2-11.8-3.5-18.7-6.7c-10.3-4.7-19.7-12.8-28-24 c-8.3-11.2-12.6-26.6-12.8-45.8c2.9,7.6,8.3,15.1,15.9,22.7c7.7,7.6,17.3,12.9,28.9,16c8.2,4.6,17.1,7.9,26.7,9.9 M1035.9,351.7 l-14.5,19.1c15.9,1.1,29.5-2.8,40.8-12.1c5.4-4.3,10-8.6,13.9-12.6c4.3-4.4,7.8-8.6,10.4-12.6 M1048.1,303.4 c-20.2,22.3-43.4,44.3-69.5,66.1c15.2,2.7,30.9-0.9,47.1-11.1c3.5-2.3,6.9-4.5,10.2-6.7c11.4-7.9,20.7-15.8,27.9-23.6  M1048.1,303.4c-16.3-7.6-26.7-18.3-31.5-32.4c12.4,6.9,26.3,9.8,41.5,8.7c2.7,0.7,5.3,1,7.7,1.2 M1076.2,346.2l-5.6,13.5 c8.7-2.3,17-5.8,24.8-10.7c7.7-5,14.6-10.8,20.4-17.4c5.8-6.6,9.9-12.2,12.4-16.8c-11.6,1.7-24.6,1.6-38.8-0.4 M1149.4,308.9 c-6.5,2.7-13.6,4.6-21.2,5.8 M1064.6,309.4c-6-1.8-11.5-3.8-16.3-6 M1194.1,113.3l41.3-45"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0716400146484375, 0, 0, 1.0716400146484375, -268.85,23.3) "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_MEMBER_1_2_STROKES",
    className: "st16",
    d: "M1300,139.7c7.3-12.9,8.7-22.7,4.4-29.2 M1300,139.7l40-48.9 c6.4-7.9,8.9-14.6,7.4-20.1 M1236.9,170.9l-0.5-0.5l-1.1-1h0.1 M1257.5,189.4c0.9,0,1.9-0.4,2.7-1 M1253,187.3 c1.6,1.4,3,2.1,4.5,2.1 M1237,171.1l16,16.3 M1260.2,188.4c0.7-0.6,1.3-1.3,1.9-2.3l37.8-46.3 M1212.1,176.6 c0,6.4-2.3,12-6.9,16.5c-4.4,4.5-9.9,6.8-16.3,6.8c-6.3,0-11.7-2.2-16.3-6.5c-0.1-0.1-0.2-0.2-0.3-0.2c-4.5-4.5-6.8-10.1-6.8-16.5 s2.3-11.9,6.8-16.5c2.4-2.3,4.9-4,7.7-5.1c2.7-1.1,5.7-1.6,8.9-1.6c6.4,0,11.9,2.3,16.3,6.8 C1209.8,164.7,1212.1,170.1,1212.1,176.6z M1201.2,176.7c0,3.5-1.2,6.4-3.7,8.9c-2.4,2.5-5.4,3.7-8.9,3.7c-3.5,0-6.4-1.2-8.9-3.7 c-2.4-2.5-3.6-5.4-3.6-8.9c0-3.5,1.2-6.5,3.6-9c2.5-2.5,5.5-3.7,8.9-3.7c3.5,0,6.5,1.2,8.9,3.7 C1200,170.1,1201.2,173.2,1201.2,176.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.8424835205078125, 0, 0, 0.8424835205078125, 1062.45,360.6) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_1_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182526875955228796070000018062872712841002427_",
    gradientUnits: "userSpaceOnUse",
    x1: -2585.655,
    y1: 258.4483,
    x2: -2572.78,
    y2: 258.4483,
    gradientTransform: "matrix(0.7098 0 0 0.7098 1972.3978 -403.3945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBF1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECECEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182526875955228796070000018062872712841002427_)"
    },
    d: "M139.5-215.2c1.2,1.2,2.7,1.9,4.5,1.9 c1.9,0,3.5-0.6,4.7-1.9c1.3-1.3,2-2.9,2-4.8c0-1.8-0.6-3.4-2-4.7c-1.2-1.2-2.8-1.9-4.7-1.9c-1.8,0-3.4,0.6-4.5,1.9 c-1.3,1.3-2,2.9-2,4.7C137.5-218.1,138.2-216.5,139.5-215.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTucanfiLogo);
export default __webpack_public_path__ + "static/media/tucanfi-logo.fd7f4810cfb5eadaec9c65cc1e1838a0.svg";
export { ForwardRef as ReactComponent };